import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
    allowedRoles?: string[]; // Opcional: para restringir por rol (ej: solo organizadores)
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles }) => {
    const { isAuthenticated, isLoading, user } = useAuth();

    // 1. Mientras verificamos el token (localStorage), mostramos un spinner o nada
    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="st-spinner st-spinner-lg border-t-[var(--st-accent-primary)]"></div>
            </div>
        );
    }

    // 2. Si no está autenticado, redirigir al Home
    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    // 3. Si hay roles requeridos y el usuario no tiene el rol, redirigir
    if (allowedRoles && user && !allowedRoles.includes(user.role)) {
        return <Navigate to="/" replace />;
    }

    // 4. Si pasa todas las validaciones, renderiza la ruta hija (Outlet)
    return <Outlet />;
};

export default ProtectedRoute;